// library imports
import { Route, Routes } from "react-router-dom";

// User Component imports
import * as SceneConfig from "_core/configs/SceneConfig";
import AccountTop from "./parts/AccountTop";


const AccountScene = () => {

    return (
        <div id="Account" className="scene-parent-root">
            <Routes>
                <Route path='' element={<AccountTop />} />
                <Route path={SceneConfig.PARTS_TOP} element={<AccountTop />} />
            </Routes>
        </div>
    );
};

export default AccountScene;